module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "gallery",
    attrs: {
      "id": "gallery"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "r1 row animateblock btt speed-1"
  }, [_c('slick', {
    staticClass: "c1 col-md-12",
    attrs: {
      "id": "gallery-carousel-1",
      "options": _vm.slickOptions
    }
  }, [_c('div', {
    staticClass: "link-modal"
  }, [_c('img', {
    staticClass: "img-responsive thumb",
    attrs: {
      "src": "landing/static/images/gallery/gallery_item_1.png",
      "alt": "Screenshot 1"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "link-modal"
  }, [_c('img', {
    staticClass: "img-responsive thumb",
    attrs: {
      "src": "landing/static/images/gallery/gallery_item_1.png",
      "alt": "Screenshot 2"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "link-modal"
  }, [_c('img', {
    staticClass: "img-responsive thumb",
    attrs: {
      "src": "landing/static/images/gallery/gallery_item_1.png",
      "alt": "Screenshot 3"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "link-modal"
  }, [_c('img', {
    staticClass: "img-responsive thumb",
    attrs: {
      "src": "landing/static/images/gallery/gallery_item_1.png",
      "alt": "Screenshot 1"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "link-modal"
  }, [_c('img', {
    staticClass: "img-responsive thumb",
    attrs: {
      "src": "landing/static/images/gallery/gallery_item_1.png",
      "alt": "Screenshot 2"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "link-modal"
  }, [_c('img', {
    staticClass: "img-responsive thumb",
    attrs: {
      "src": "landing/static/images/gallery/gallery_item_1.png",
      "alt": "Screenshot 3"
    }
  })])])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-header"
  }, [_c('h2', {
    staticClass: "section-title"
  }, [_vm._v("Галерея")]), _vm._v(" "), _c('h3', {
    staticClass: "section-subtitle"
  }, [_vm._v("Современный удобный дизайн адаптированный под все распространенные устройства")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-73dcc1a4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/Gallery.vue
// module id = 1235
// module chunks = 1